import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { ws } from "./api";

const Ctx = createContext(null);

export const WorkspaceProvider = ({ children }) => {
  const [me, setMe] = useState(null);
  const refresh = useCallback(async () => {
    try {
      setMe(await ws("/crm/workspace/me"));
    } catch {
      setMe({ error: true });
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const role = me?.crm_role;
  const value = {
    me,
    role,
    refresh,
    isAdmin: role === "business_owner" || role === "business_admin",
    isManagerUp: ["business_owner", "business_admin", "manager"].includes(role),
    can: (roles) => !roles || roles.includes(role),
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useWorkspace = () => useContext(Ctx);
